import React from "react";
import ReactDOM from "react-dom";
import ConfirmModal from "../components/complex/ConfirmModal";

export default function getUserConfirmation(message, callback) {
  const node = document.getElementById("prompt");
  const cleanUp = result => {
    ReactDOM.unmountComponentAtNode(node);
    callback(result);
  };

  ReactDOM.render(<ConfirmModal message={message} callback={cleanUp} />, node);
}
